var _circle, _mask, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealthcareWorker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 219,
    height: 237,
    viewBox: "0 0 219 237",
    fill: "none",
    id: "svg35",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: -109.5,
    cy: 127.5,
    r: 109.5,
    fill: "#f2f4fc",
    id: "circle1",
    transform: "scale(-1,1)"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0_215_7788",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -92,
    width: 219,
    height: 329
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 219,127.5 C 219,187.975 169.975,237 109.5,237 49.0248,237 0,187.975 0,127.5 0,67.0248 49.0248,-92 109.5,-92 169.975,-92 219,67.0248 219,127.5 Z",
    fill: "#ebf5ff",
    id: "path1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_215_7788)",
    id: "g35",
    transform: "matrix(-1,0,0,1,219,0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_215_7788)",
    id: "g34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 206.698,218.552 10.526,-4.369 2.12,-1.39 -2,-3.5 -2.5,-3.5 -5.5,-5.5 -5.5,-10.5 -8,-18.5 -6.824,-15.395 c 0,0 -9.08,-8.681 -18.275,-8.758 -9.196,-0.077 -22.517,1.367 -22.517,1.367 l -8.058,-7.142 -5.326,-1.072 1,9.5 v 3.5 l -14,16 -10.764,8.683 -14.7281,-22.636 8.9921,-2.047 -2,-8.5 -6.9921,3 -7.0081,8.144 -4.2116,1.828 -16.7884,3.528 c 0,0 -12.0169,8.476 -13,13.5 -6,10 -7.2494,20.744 -7.5,27 -0.2507,6.256 -2.9444,17.5 -2.9444,17.5 l -0.5556,5 17.5,2 c 6.795,18.635 5.942,36.787 18,54.5 0,0 -17.8224,10 -27.5,31.5 l -4.5,17 H 198.621 l -1.277,-16.5 c 0,0 -8.671,-39.036 -21.703,-47.832 l -4.896,-3.465 5.147,-20.5 -1.889,-6.198 32.695,-16.169 z",
    fill: "#3455fc",
    id: "path2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 172.113,235.913 13.731,-9.122 28.603,-12.244 3.123,8.681 15.172,36.649 c 0,0 2.487,2.791 1.658,10.183 -0.829,7.391 -4.646,10.548 -4.646,10.548 0,0 -11.104,9.085 -13.61,10.279 -2.506,1.193 -25.697,9.068 -25.697,9.068 -35.614,11.089 -51.184,12.966 -73.218,11.349 l -13.417,8.258 -5.9682,1.729 -21.5,1 -1.5,-1.5 1.5,-4 13.7425,-13.494 -7.6533,-2.368 -0.9832,-3.195 2.2941,-1.81 15.2873,-2.81 c 0,0 6.5928,-5.178 8.3858,-5.178 1.793,0 34.715,-8.443 41.906,-10.484 19.711,-5.593 35.706,-16.535 35.706,-16.535 l -7.055,-16.111 -5.13,-9.262 z",
    fill: "#f4f1fa",
    id: "path3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 61.9209,226.022 -11.5771,-1.229 -3.5946,47 -77.4054,-29.5 v 33 l 81,40.5 c 0,0 11.1536,-23.589 29.5,-35 -13,-34 -17.9229,-54.771 -17.9229,-54.771 z",
    fill: "#f4f1fa",
    id: "path4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 109.844,177.793 14.5,-11 14.283,-17.477 -3.065,0.231 -4.916,-37.092 c 0,0 14.227,-12.8773 17.639,-21.212 3.412,-8.3346 5.899,-16.5538 4.222,-20.288 -1.677,-3.7342 -3.239,-6.8717 -7.287,-7.8149 -4.049,-0.9432 -9.909,-0.2118 -9.909,-0.2118 l -6.072,4.3695 -5.302,-10.6253 -4.53,-9.6627 c 0,0 -27.0662,0.2117 -39.3654,-4.9277 C 67.7424,36.9427 61.2843,32.6888 61.2843,32.6888 l -3.8556,-4.9661 c 0,0 -3.4121,3.6764 -4.4917,7.0642 -1.0796,3.3877 -4.8387,17.266 -4.8387,17.266 L 47.8477,64.9302 49.5,79.5 c 0,0 2.5952,14.3024 3,20 0.4048,5.698 3.571,15.67 6,19 2.429,3.33 5.5,7.5 5.5,7.5 l 6,3.5 7,1.5 c 10.4585,-0.53 12.8362,0.146 21.7025,-3.185 l 5.8415,25.447 -9.1573,1.983 14.0533,20.846 z",
    fill: "#f4f1fa",
    id: "path5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 134.715,72.4146 c 0,0 9.234,-9.2971 11.412,4.7544",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 50.5487,82.8881 C 50.581,83.8744 38.8231,75.1089 34.6831,65.9878 30.5577,57.8842 31.0974,50.7429 31.0974,50.7429 c 0,0 0.8868,-19.672 9.4269,-26.1011 8.54,-6.429 15.3644,-9.0853 15.3644,-9.0853 l 6.8243,-1.3089 c 0,0 13.9764,-7.37222 21.3791,-8.96985 7.4027,-1.59764 29.3219,-5.100883 45.6689,-2.75255 16.348,2.34833 25.428,4.0422 34.083,10.5482 8.656,6.5061 10.854,14.6867 11.413,21.4815 0.559,6.7947 1.022,15.8608 0,18.6519 -1.022,2.791 -0.482,6.814 -0.482,6.814 l -0.015,2.7835 c -0.102,19.7392 16.79,33.9366 30.941,47.6987 2.137,2.078 3.833,4.444 4.815,7.129 7.807,15.711 7.239,30.492 5.629,32.145 -0.308,1.655 -6.901,16.381 -6.901,16.381 l -7.962,6.891 -3.91,1.958 c 0,0 -3.973,-10.973 -7.372,-16.507 -3.836,-5.043 -9.52,-9.691 -17,-11 -7.48,-1.309 -25.715,1.026 -25.715,1.026 l -4.608,-4.081 -3.45,-3.06 -4.878,-1.059 -3.682,-27.834 c 0,0 12.261,-12.9924 14.536,-16.3994 3.546,-3.4207 9.529,-19.9373 7.865,-23.618 -0.54,-3.6572 -1.966,-6.6408 -4.896,-7.9689 -2.931,-1.3282 -10.642,-1.7324 -10.642,-1.7324 l -5.918,3.6187 -2.352,0.9625 -9.832,-20.2881 c 0,0 -26.256,-1.9248 -34.8732,-3.5609 C 75.9376,41.8693 70.2506,38.6356 70.2506,38.6356 L 58.549,30.0314 55.4646,27.7794 c 0,0 -7.5762,16.2073 -7.4413,20.2687 0.135,4.0615 -0.1349,16.958 -0.1349,16.958 l 2.6989,17.959 z",
    fill: "#ffffff",
    id: "path7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m 77,131.5 10,-0.5 11.5,-3 19,-8.5 c 0.239,-0.119 0.522,-0.265 0.846,-0.435 l -5.34,3.166 20.494,13.269 -3.254,-23.489 -0.184,0.109 c 1.268,-0.82 2.587,-1.695 3.938,-2.62 7.6,-5.2 15.167,-19.8333 18,-26.5 l 1,-7 -1,-8 -6.5,-5 c 1.333,4.8684 0.6,18.8842 -13,36 -13.6,17.116 -42,28.298 -55.5,32.5 z",
    fill: "#222838",
    id: "path8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 214.197,215.048 c 9.331,22.598 17.832,43.386 17.832,43.386 0,0 13.9,23.002 -25.639,36.438 -39.255,13.339 -70.281,19.368 -88.628,16.477 -0.258,-0.04 -0.518,0.021 -0.732,0.17 -6.473,4.521 -12.148,8.411 -18.326,9.622 -5.86,1.148 -22.8441,2.617 -23.7116,0 -0.8675,-2.618 5.0507,-7.661 5.0507,-7.661 l 16.0162,-16.32 c 0.5966,-0.608 1.0219,-1.364 1.4016,-2.127 1.0982,-2.205 4.3361,-6.762 12.5981,-7.674 10.988,-1.212 50.758,-12.102 66.277,-21.322 3.606,-2.305 5.739,-3.68 6.948,-4.464 0.821,-0.532 1.125,-1.579 0.725,-2.47 l -10.931,-24.364",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 77.7889,158.937 c -4.6042,-5.692 -3.7925,-19.65 -2.8112,-25.918 5.597,0 18.3729,-3.395 24.0613,-5.092 l 3.923,17.431 c -8.4737,1.88 -12.5537,8.313 -13.5345,11.294 z",
    fill: "#ffffff",
    id: "path10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 192.157,162.356 c 1.773,4.177 7.773,18.335 10.028,23.744",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 117.363,119.576 c 0,0 -20.6223,12.693 -40.3628,11.423 C 49.4801,129.228 51.081,84.9623 48.4646,66.3151 c -3.3543,-23.9067 7.981,-38.5934 7.981,-38.5934 0,0 12.0294,19.8838 63.6554,19.2678 3.836,8.9699 8.598,21.0002 8.598,21.0002 6.728,-9.22 18.911,-6.2943 22.69,0 3.778,6.2943 0,20.981 -6.304,27.6795 -2.525,6.7178 -14.439,16.7848 -14.439,16.7848 l 4.916,37.092",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 66.9524,76.3838 c 0,0 -6.7279,10.6637 -4.6267,12.3383 2.1013,1.6747 6.728,6.2943 6.728,6.2943",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 74.7102,102.446 c 0,0 6.9032,0 8.641,-7.3396",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 98.7037,127.853 5.6153,24.46 c 0.124,0.543 -0.219,1.083 -0.763,1.201 l -8.1295,1.768",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 197.463,174.781 c 0,0 22.459,-6.468 18.97,-40.115 -1.107,-10.671 -5.79,-18.361 -11.669,-23.887 -14.2,-13.3462 -30.858,-28.5803 -30.858,-48.0676 v 0 c 0,-3.6359 0.557,-7.2397 1.134,-10.8294 C 177.007,39.651 177.969,10.2355 143.428,4.35345 99.5706,-3.115 73.1022,7.02901 61.9404,14.7669 48.9086,14.7669 30.5754,26.7781 31.1152,50.2806 31.5568,70.2041 45.3334,80.1657 49.5,82.728",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 74.8959,133.05 c 0,0 -2.9881,17.67 2.8146,26.062",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 134.329,140.267 c 0,0 12.993,-2.079 0,14.764 -10.095,13.085 -19.119,19.664 -22.643,21.948 -0.874,0.566 -2.007,0.285 -2.575,-0.588 L 95.388,155.3 c 0,0 -4.5496,-7.372 5.089,-9.201",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 139.206,141.346 6.901,7.141 2.796,-0.27 12.742,-1.27 c 0,0 22.594,-2.599 30.421,15.187",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 94.3086,167.139 c 0,0 4.1323,7.166 14.7874,18.99 0.6,0.667 1.58,0.845 2.372,0.423 21.33,-11.373 31.189,-30.673 31.189,-30.673 0.976,-1.716 3.029,-5.553 3.436,-7.183",
    stroke: "#ffffff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 95.4452,148.487 c 0,0 -3.337,2.746 -6.381,8.162 l -17.2536,3.734 c 0,0 -21.7646,3.811 -23.9816,43.56 m 2.015,110.849 -80.5527,-39.257 v -33.762 l 74.9516,29.06 c 1.2395,0.48 2.5909,-0.355 2.7021,-1.679 0.5059,-6.025 1.7672,-21.981 2.899,-43.862",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 202.128,185.991 c 1.927,4.095 4.588,13.531 12.05,19.394 3.268,2.568 4.472,5.471 4.88,6.82 0.134,0.443 -0.102,0.883 -0.531,1.058 -4.817,1.969 -32.287,13.239 -36.312,15.837 -3.738,2.412 -10.047,6.177 -11.893,7.274 -0.321,0.191 -0.719,0.183 -1.003,-0.06 -1.044,-0.892 -3.528,-3.514 -4.84,-9.12 -0.963,-4.119 -3.2,-13.897 -4.086,-15.668",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 210.44,209.947 c 0,0 -33.218,11.511 -38.596,17.844",
    stroke: "#ffffff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 47.8482,203.941 c 0,0 -1.5944,11.18 -3.6284,19.091 -0.1415,0.551 0.194,1.111 0.7505,1.226 7.441,1.533 16.97,1.762 16.97,1.762",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 60.092,219.335 c 0,0 -6.9625,0.048 -8.8518,-0.818",
    stroke: "#ffffff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 65.4876,185.155 c 0,0 -7.769,23.599 -3.5664,40.865 3.7026,15.212 14.7932,46.134 17.3798,53.277 0.3194,0.882 -0.0117,1.855 -0.778,2.396 -5.7479,4.06 -28.3878,21.57 -30.6746,46.922 M 193.376,298.914 c 4.691,12.962 5.352,22.574 5.262,29.701",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 114.937,208.35 h 26.198 v 17.67 H 114.937 V 213.2",
    fill: "#ffffff",
    id: "path27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 114.937,208.35 h 26.198 v 17.67 H 114.937 V 213.2",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 119.793,213.778 c 0,0 10.796,-0.77 14.921,0",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 119.793,219.726 c 0,0 8.058,-0.462 11.143,0",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 81.3478,77.8808 c 0.6321,0 1.1445,-1.5397 1.1445,-3.4389 0,-1.8993 -0.5124,-3.439 -1.1445,-3.439 -0.632,0 -1.1444,1.5397 -1.1444,3.439 0,1.8992 0.5124,3.4389 1.1444,3.4389 z",
    fill: "#222838",
    id: "path31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 55.9025,79.6972 c 0.6321,0 1.1444,-1.5397 1.1444,-3.4389 0,-1.8993 -0.5123,-3.439 -1.1444,-3.439 -0.6321,0 -1.1444,1.5397 -1.1444,3.439 0,1.8992 0.5123,3.4389 1.1444,3.4389 z",
    fill: "#222838",
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 78.6917,59.0984 c 5.3707,-3.4973 12.3085,-2.8436 18.1522,3.8352",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 55.8183,59.1006 c -4.8527,-0.8775 -8.319,1.6562 -9.0026,6.3859",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path34"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs35"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_215_7788"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 268,
    height: 353,
    fill: "#ffffff",
    transform: "translate(-32.1562,0.292969)",
    id: "rect35",
    x: 0,
    y: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthcareWorker);
export default __webpack_public_path__ + "static/media/HealthcareWorker.ff4071de493fec8cd461694c57f8f7d9.svg";
export { ForwardRef as ReactComponent };